import { useCallback } from 'react';
import { useMutation } from 'react-query';
import request from '../../../../../helpers/request';
import { getDataAfterSubmit } from '../utils/getDataAfterSubmit';

export const useSubmit = ({ url, errMsg, onSuccess }) => {
  const change = useCallback(
    ({ ids, value }) => request.put(url, { ids, value }, errMsg, 'Error'),
    [url, errMsg]
  );

  const changeMutation = useMutation(change, {
    onSuccess: async (res, { requests }) => {
      if (res !== 'Error' && typeof onSuccess === 'function') {
        const data = await getDataAfterSubmit({ items: res, requests });
        onSuccess(data, errMsg);
      }
    },
  });

  return {
    submit: changeMutation.mutate,
    submitAsync: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
